import {
	AppEnumHelper,
	DetailSection,
	PermissionEnums,
} from "@/Shared";


import { ResourceAccessModel } from "../Models";

export class ResourceAccessViewModel {
	public id!: number;
	public role: string;
	public model: ResourceAccessModel;
	public resource!: string;
	public allRecords!: string;

	public cardHeaderTitle!: string;

	public write!: string;
	public read!: string;
	public delete!: string;
	public restore!: string;
	public export!: string;
	public execute!: string;
	public audit!: string;

	constructor(id: number, role: string, resourceAccess: ResourceAccessModel, viewEnums: PermissionEnums) {
		this.id = id;
		this.role = role;
		this.model = resourceAccess;

		this.resource = AppEnumHelper.getLabel(viewEnums.ResourceTypeEnum, resourceAccess.resource);

		this.allRecords = this.boolRender(this.model.allRecords);

		console.table(resourceAccess);

		const hasAccess = (access: string) => (resourceAccess.rightList ?? []).includes(access);

		
		this.write = this.boolRender(hasAccess('write'));
		this.read = this.boolRender(hasAccess('read'));
		this.delete = this.boolRender(hasAccess('delete'));
		this.restore = this.boolRender(hasAccess('restore'));
		this.export = this.boolRender(hasAccess('export'));
		this.execute = this.boolRender(hasAccess('execute'));
		this.audit = this.boolRender(hasAccess('audit'));

		this.cardHeaderTitle = this.resource;
	}

	boolRender = (val: boolean) => val ? '✅ Oui' : '❌ Non';

	getAllSections = (): DetailSection[] => {
		const sections: DetailSection[] = [{
			sectionFn: () => { return [{ label: "N°", value: "Unknown" }] },
			legend: "Détails de la ResourceAccess",
			type: "box",
		}];

		return sections;
	};
}